import { render } from "./UserAdminModal.vue?vue&type=template&id=0b5de1cf"
import script from "./UserAdminModal.vue?vue&type=script&lang=js"
export * from "./UserAdminModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__